import type { RequestHandler } from 'msw';
import type { SetupWorker } from 'msw/browser';

const NOOP_WORKER: SetupWorker = {
  events: {
    on: () => undefined,
    removeListener: () => undefined,
  },
  start: async () => undefined,
} as unknown as SetupWorker;

export function isMswEnabled(): boolean {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return false;
  }
  return import.meta.env.VITE_ENABLE_MSW === 'true';
}

export async function createWorker(
  handlers: RequestHandler[]
): Promise<SetupWorker> {
  if (!isMswEnabled()) {
    return NOOP_WORKER;
  }
  const { setupWorker } = await import('msw/browser');
  return setupWorker(...handlers);
}

export async function startWorker(worker: SetupWorker): Promise<boolean> {
  if (worker === NOOP_WORKER) {
    return false;
  }
  try {
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        url: '/mockServiceWorker.js',
      },
    });
    return true;
  } catch (error) {
    console.warn(
      '[MSW] Service worker registration failed, continuing without mocks:',
      error
    );
    return false;
  }
}
